import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ArrowRight from '@deliveroo/icon-set/react/ArrowRight';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import P from '@deliveroo/consumer-component-library/components/P';
import Row from '@deliveroo/consumer-component-library/components/Row';
import UnstyledButton from '@deliveroo/consumer-component-library/components/UnstyledButton';
import withPlaceholder from '@deliveroo/consumer-component-library/components/withPlaceholder';

import styles from './styles.scss';

const PickupShowcaseBanner = ({
  body,
  cta,
  imageUrl,
  isPlaceholder,
  onClick,
  placeholderClassName,
  title,
}) => {
  const badge = <img alt="" className={styles.badge} src={imageUrl} />;

  const renderBody = useCallback(
    ({ color, size }) => (
      <Fragment>
        <P color={color} size={size} adjacentVerticalSpacing="x-small">
          {body}
        </P>
        <P size="regular" color="teal" adjacentVerticalSpacing="x-small">
          {cta}
          <Icon component={ArrowRight} size={18} spacing="0 0 0 small" />
        </P>
      </Fragment>
    ),
    [body, cta],
  );

  const outerClass = classnames(
    styles.outer,
    { [placeholderClassName]: isPlaceholder },
    { [styles.isPlaceholder]: isPlaceholder },
  );
  const innerClass = classnames(
    styles.inner,
    { [placeholderClassName]: isPlaceholder },
    { [styles.isPlaceholder]: isPlaceholder },
  );

  return (
    <div className={outerClass}>
      <UnstyledButton isBlock onClick={onClick}>
        <div className={innerClass}>
          <Row left={badge} secondary={renderBody}>
            <P isBold>{title}</P>
          </Row>
        </div>
      </UnstyledButton>
    </div>
  );
};

PickupShowcaseBanner.propTypes = {
  body: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  isPlaceholder: PropTypes.bool,
  onClick: PropTypes.func,
  placeholderClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
};

PickupShowcaseBanner.defaultProps = {
  isPlaceholder: false,
  onClick() {},
  placeholderClassName: undefined,
};

PickupShowcaseBanner.placeholderProps = {
  body: 'placeholder',
  cta: 'placeholder',
  imageUrl: '#',
  title: 'placeholder',
};

export default withPlaceholder(PickupShowcaseBanner);
